import styled from 'styled-components';

export const SummaryContainer = styled.div`
  margin-top: 32px;
  padding-bottom: 30px;
`;

export const SummaryBox = styled.div`
  background:
    repeating-linear-gradient(
      45deg,
      #f9fafb,
      #f9fafb 10px,
      #f3f4f6 10px,
      #f3f4f6 20px
    ),
    white;
  padding: 25px 20px;
  border-radius: 4px;
  position: relative;
  border: 3px solid #d1d5db;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);

  &::before {
    content: '💳';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 120px;
    opacity: 0.03;
    pointer-events: none;
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 8px;
    background: linear-gradient(to right, #10b981, #059669, #047857);
  }
`;

export const SummaryItem = styled.div`
  background: white;
  padding: 12px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: #4b5563;
  position: relative;
  z-index: 1;
  border: 1px solid #e5e7eb;
`;

export const Divider = styled.div`
  border-top: 2px solid #ccc;
  margin: 16px 0;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  color: #000;
`;
